/**
 * Mesmo critério do rodapé (CreditsBalloon) / formik em DashboardRoutes:
 * - creditsBonuzPlans = BNZs do plano mensal (Essencial / Start)
 * - saldoFinal = balance bruto da API (créditos adquiridos / fora do plano)
 * - balance exibido como total utilizável = saldoFinal + creditsBonuzPlans
 *
 * Importante: sempre operar sobre cópia do wallet — nunca mutar o objeto do Apollo Cache.
 */
export default function mergeBonuzPlansWallet(wallet, subscription) {
  if (!wallet) return wallet
  const w = { ...wallet }
  const planId = subscription?.planIdentifier
  const active = subscription?.active
  if (
    active &&
    planId &&
    (planId === 'plano-essencial' || planId === 'plano-start')
  ) {
    const creditsBonuzPlans = Number(w.creditsBonuzPlans) || 0
    const rawBalance = Number(w.balance) || 0
    w.saldoFinal = rawBalance
    w.balance = rawBalance + creditsBonuzPlans
  }
  return w
}
